export default __webpack_public_path__ + "static/media/black-mebnu.ed04ee2a.svg";